import { forwardRef } from 'react';
import { getSidebarContentSectionStyles } from './SidebarContentStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const SidebarContent = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    ...rest
  } = _ref;
  return jsx("section", {
    css: getSidebarContentSectionStyles,
    ref: ref,
    ...rest,
    children: children
  });
});
SidebarContent.displayName = 'SidebarContent';

export { SidebarContent };
//# sourceMappingURL=SidebarContent.js.map
